import axios from 'axios';

export const getAxiosInstance = (apiEnvironment, ssId = null) => {
	const baseURL =
		apiEnvironment && apiEnvironment !== 'prod'
			? `https://${apiEnvironment}.identity.api.ashcompanies.com`
			: `https://identity.api.ashcompanies.com`;

	const instance = ssId
		? axios.create({
				baseURL,
				withCredentials: true,
				headers: {
					'X-ss-id': ssId,
				},
		  })
		: axios.create({
				baseURL,
				withCredentials: true,
		  });

	return instance;
};
